var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 343,
    height: 675,
    viewBox: "0 0 343 675",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 51.6746C0.5 23.4328 24.4621 0.5 54.069 0.5H288.931C318.538 0.5 342.5 23.4328 342.5 51.6746V623.325C342.5 651.567 318.538 674.5 288.931 674.5H54.069C24.4621 674.5 0.5 651.567 0.5 623.325V51.6746Z",
    fill: "#141922",
    stroke: "#3C485A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.b50b29eafcff44de886ea54866461e20.svg";
export { ForwardRef as ReactComponent };